export default __webpack_public_path__ + "static/media/ask-me-bot-blue-filled.e3aad30a.svg";